import { isUserSignedIn } from '@/dashboard/utils/user/isUserSignedIn';
import { useAppStore } from '@/dashboard/store/appStore';
import { storeToRefs } from 'pinia';
import { useWorkspaceStore } from '@/dashboard/store/workspaceStore';

export async function loadWorkspacePage(shortLink: string) {
  const signedIn = isUserSignedIn();
  const appStore = useAppStore();
  const workspaceStore = useWorkspaceStore();
  const { workspace, currentWorkspaceUser } = storeToRefs(appStore);

  if (!signedIn) {
    window.location.replace('/sign_in');
    return;
  }

  try {
    workspaceStore.setPageLoader(true);
    await appStore.loadWorkspaceByShortLink(shortLink);
  } finally {
    workspaceStore.setPageLoader(false);
  }

  if (!workspace.value) {
    window.location.replace('/401');
  }
}
